import Header from '../../../components/Header';
import { useCourses } from '../hooks/useCourses';
import { CourseCard } from '../components/CourseCard';

export function CourseListPage() {
  const { courses, loading, error } = useCourses();

  return (
    <>
      <Header />
      <div className="container" style={{ paddingTop: 'var(--space-xl)', paddingBottom: 'var(--space-2xl)' }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 'var(--space-xs)' }}>קורסים</h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-xl)' }}>
          בחרו קורס והתחילו ללמוד
        </p>

        {loading && (
          <p style={{ color: 'var(--color-text-muted)', textAlign: 'center', padding: 'var(--space-2xl)' }}>
            Loading courses...
          </p>
        )}

        {error && (
          <p style={{ color: 'var(--color-incorrect)', textAlign: 'center', padding: 'var(--space-2xl)' }}>
            {error}
          </p>
        )}

        {!loading && !error && courses.length === 0 && (
          <p style={{ color: 'var(--color-text-muted)', textAlign: 'center', padding: 'var(--space-2xl)' }}>
            No courses available yet.
          </p>
        )}

        <div className="grid grid-cols-3" style={{ gap: 'var(--space-lg)' }}>
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      </div>
    </>
  );
}
